// @flow
import * as React from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import colors from '../../assets/css/colors';

import { EllipsisRow } from '../../components';

const LeagueNameStyled = styled.div`
	width: 100%;
	.commissioner {
		font-size: 12px;
		line-height: 1;
		color: ${({ theme }) =>
		_.get(theme, 'leagueName.children.commissioner.color') || colors.darkGrey};
	}
`;
const EllipsisRowStyledWrapper = styled.div`
	width: 100%;
	max-width: 100%;
	margin-bottom: 0.3em;
`;
const EllipsisRowStyled = styled(EllipsisRow)`
	color: ${({ theme }) => _.get(theme, 'leagueName.color') || colors.nrlDarkGreen};
	font-size: 14px;
	font-weight: bold;
	line-height: 1;
	display: block;
`;

type Props = {
	name: string,
	lastname?: string,
	firstname?: string,
	commissioner?: string,
	width: string,
	className?: string,
	theme?: {
		leagueName?: {
			color?: string,
			children?: {
				commissioner?: {
					color?: string
				}
			}
		}
	}
};

export const LeagueName = (
	{ name, lastname = '', firstname = '', width, className, commissioner }: Props
) => (
	<LeagueNameStyled className={className}>
		<EllipsisRowStyledWrapper>
			<EllipsisRowStyled width={width}>
				{name}
			</EllipsisRowStyled>
		</EllipsisRowStyledWrapper>
		<p className="commissioner">
			{commissioner ? commissioner : `${firstname[0]}. ${lastname}`}
		</p>
	</LeagueNameStyled>
);

export default LeagueName;


// WEBPACK FOOTER //
// ./src/components/Leagues/LeagueName.js